export const defaultPackages = [
    {
        name: 'Bone Health Basic Panel',
        includedTests: 5,
        sellingPrice: 400,
        totalPrice: 800,
        discount: 50,
        includedParameters: 5,
        overview:
            'Bone Health Panel- Basic assesses key markers and minerals vital for bone health, such as calcium and vitamin D levels, which are essential for maintaining strong bones. This panel helps identify potential issues like osteoporosis or calcium deficiency, enabling early detection and intervention.',
        tests: [
            {
                id: 'lb-9623637360',
                name: 'Calcium, Serum',
            },
            {
                id: 'lb-8797706528',
                name: 'Phosphorus, Serum',
            },
            {
                id: 'lb-442047493',
                name: 'CRP (C-Reactive Protein)',
            },
            {
                id: 'lb-9356134692',
                name: 'ALP (Alkaline Phosphatase)',
            },
            {
                id: 'lb-4535039408',
                name: 'Rheumatoid Factor, Serum (Quantitative)',
            },
        ],
    },
    {
        name: 'Thyroid Preventive Care',
        includedTests: 2,
        sellingPrice: 550,
        totalPrice: 1100,
        discount: 50,
        includedParameters: 12,
        overview:
            'The Thyroid Basic Health Package is aimed at thoroughly evaluating the health and function of the thyroid gland, as well as providing additional insights into related aspects of overall health. It goes beyond the standard thyroid profile by including Free T3 (FT3), Free T4 (FT4), Complete Blood Count (CBC), and Vitamin D 25 Hydroxy tests.',
        tests: [
            {
                id: 'lp-276338408',
                name: 'Thyroid Profile (T3, T4, TSH)',
            },
            {
                id: 'lp-9829914890',
                name: 'Lipid Profile',
            },
        ],
    },
    {
        name: 'Healthy Heart Basic Panel',
        includedTests: 6,
        sellingPrice: 600,
        totalPrice: 1200,
        discount: 50,
        includedParameters: 60,
        overview:
            'Healthy Heart- Basic Package is a carefully designed set of diagnostic tests focused on assessing and tracking heart health. It encompasses a variety of tests that examine vital indicators for heart diseases, such as cholesterol levels, liver enzymes, electrolyte balance, and overall blood composition. This package offers a thorough understanding of cardiovascular health and related aspects.',
        tests: [
            {
                id: 'lb-7918188121',
                name: 'ESR (Erythrocyte Sedimentation Rate, 1 Hour)',
            },
            {
                id: 'lb-864488721',
                name: 'HsCRP (High Sensitivity C Reactive Protein)',
            },
            {
                id: 'lp-2309153556',
                name: 'Kidney Function Tests (KFT)',
            },
            {
                id: 'lp-6835926294',
                name: 'Liver Function Test (LFT)',
            },
            {
                id: 'lp-9829914890',
                name: 'Lipid Profile',
            },
            {
                id: 'lp-2493983235',
                name: 'Complete Blood Count (CBC)',
            },
        ],
    },

    {
        name: 'Advance Full Body Checkup',
        includedTests: 12,
        sellingPrice: 750,
        totalPrice: 1500,
        discount: 50,
        includedParameters: 93,
        overview:
            'The Advanced Full Body Checkup is your gateway to proactive health management. Regular lab investigations are vital for catching health concerns early, allowing for timely intervention. This comprehensive test package empowers everyone to take charge of their well-being, providing valuable insights for personalised health planning.',
        tests: [
            {
                id: 'lb-7918188121',
                name: 'ESR (Erythrocyte Sedimentation Rate, 1 Hour)',
            },
            {
                id: 'lb-6907652548',
                name: 'Vitamin B12',
            },
            {
                id: 'lb-5163005287',
                name: '25-Hydroxy Vitamin D',
            },
            {
                id: 'lb-9927104553',
                name: 'HbA1c (Glycosylated Hemoglobin)',
            },
            {
                id: 'lb-5349691605',
                name: 'FBS (Fasting Blood Sugar)',
            },
            {
                id: 'lp-2309153556',
                name: 'Kidney Function Tests (KFT)',
            },
            {
                id: 'lp-276338408',
                name: 'Thyroid Profile (T3, T4, TSH)',
            },
            {
                id: 'lp-6835926294',
                name: 'Liver Function Test (LFT)',
            },
            {
                id: 'lp-7446288715',
                name: 'Urine Routine and Microscopy',
            },
            {
                id: 'lp-9082565902',
                name: 'Iron Profile',
            },
            {
                id: 'lp-9829914890',
                name: 'Lipid Profile',
            },
            {
                id: 'lp-2493983235',
                name: 'Complete Blood Count (CBC)',
            },
        ],
    },
];
